












































import { Prop, Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'MakeupTraitPreview',
  filters: {
    convertToHex(value: number) {
      return `#${value.toString(16)}`;
    },
  },
})
export default class MakeupTraitPreview extends Vue {
  @Prop(String) readonly categoryKey: string | undefined;
  @Prop(Number) readonly makeupTone: number | undefined;
  @Prop(Boolean) readonly isSelected: boolean | undefined;
  @Prop(Boolean) readonly tabNavigationEnabled: boolean | undefined;

  get borderRadius(): string {
    if (this.categoryKey === 'blush_tone') {
      return '8px';
    }
    return '50%';
  }
}
